import { BlockComponentProps } from '../core/types'
import { coreBlockComponents as builtInBlockComponents } from './CoreBlockComponents'

export class BlockComponentRegistry {
    private static instance: BlockComponentRegistry
    private blocks: Map<
        string,
        {
            component: React.ComponentType<BlockComponentProps<unknown>>
            schema: unknown
        }
    > = new Map()

    constructor() {
        this.blocks = new Map()
        this.registerBuiltInBlocks()
    }

    static getInstance() {
        if (!BlockComponentRegistry.instance) {
            BlockComponentRegistry.instance = new BlockComponentRegistry()
        }
        return BlockComponentRegistry.instance
    }

    register<T, S>(
        blockType: string,
        blockComponent: {
            component: React.ComponentType<BlockComponentProps<T>>
            schema: S
        }
    ) {
        this.blocks.set(blockType, {
            component: blockComponent.component as React.ComponentType<
                BlockComponentProps<unknown>
            >,
            schema: blockComponent.schema,
        })
    }

    getBlock(type: string) {
        return this.blocks.get(type)
    }

    remove(type: string) {
        this.blocks.delete(type)
    }

    registerBuiltInBlocks() {
        builtInBlockComponents.forEach(block => {
            this.register<object, typeof block.schema>(block.type, {
                component: block.component as React.ComponentType<BlockComponentProps<unknown>>,
                schema: block.schema,
            })
        })
    }

    unregisterBuiltInBlocks() {
        builtInBlockComponents.forEach(block => {
            this.remove(block.type)
        })
    }
}
